import { AnyT, jsonArrayMember, jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class CollectionResponse<Item> {
  @jsonMember(Number)
  public readonly page!: number;

  @jsonMember(Number)
  public readonly pages!: number;

  @jsonMember(Number)
  public readonly pageSize!: number;

  @jsonMember(Number)
  public readonly total!: number;

  @jsonArrayMember(AnyT)
  public readonly items!: Item[];

  public constructor(
    page: number,
    pages: number,
    pageSize: number,
    total: number,
    items: Item[],
  ) {
    this.page = page;
    this.pages = pages;
    this.pageSize = pageSize;
    this.total = total;
    this.items = items;
  }
}
